export default "__VITE_PUBLIC_ASSET__e13c4ead__"